/*
 * Copyright (c) 2022-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';


export const TextElementOptions = [
    {label: 'Header (sm)', value: 'header-sm'}, {
        label: 'Header',
        value: 'header'
    }, {
        label: 'Header (lg)',
        value: 'header-lg'
    }, {
        label: 'Header (xl)',
        value: 'header-xl'
    }, {
        label: 'Header (xxl)',
        value: 'header-xxl'
    }, {
        label: 'Text',
        value: 'text'
    }, {
        label: 'Text (sm)',
        value: 'text-sm'
    }, {
        label: 'Text (xs)',
        value: 'text-xs'
    }]


function TextElement(props) {
    let className = props.className ?? ""
    let style = props.style ?? {}

    switch (props.textAlign) {
        case "left":
            className += " text-left";
            break;
        case "center":
            className += " text-center";
            break;
        case "right":
            className += " text-right";
            break;
        default:
            break;
    }


    switch (props.textType) {
        case 'header-sm':
            return <h5 style={style} className={`text-sm font-bold font-headline ${className}`}>{props.children}</h5>
        case 'Header':
        case 'header':
            return <h4 style={style} className={`text-base font-bold font-headline  ${className}`}>{props.children}</h4>

        case 'header-lg':
            return <h3 style={style} className={`text-lg font-bold font-headline  ${className}`}>{props.children}</h3>
        case 'header-xl':
            return <h2 style={style} className={`text-xl font-bold font-headline  ${className}`}>{props.children}</h2>
        case 'header-xxl':
            return <h1 style={style} className={`text-2xl font-bold font-headline  ${className}`}>{props.children}</h1>

        case 'Text':
        case 'text':
            return <div style={style} className={`${className}`}>{props.children}</div>
        case 'text-sm':
            return <div style={style} className={`text-sm ${className}`}>{props.children}</div>
        case 'text-xs':
            return <div style={style} className={`text-sm italic ${className}`}>{props.children}</div>
        default:
            return (<div>ERROR</div>)

    }


}


export default TextElement;